/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookSummaryViewModel
 */
export interface BookSummaryViewModel {
    /**
     * 
     * @type {number}
     * @memberof BookSummaryViewModel
     */
    totalBookValue: number;
    /**
     * 
     * @type {number}
     * @memberof BookSummaryViewModel
     */
    averagePortfolioValue: number;
    /**
     * 
     * @type {number}
     * @memberof BookSummaryViewModel
     */
    averageInvestmentValue: number;
    /**
     * 
     * @type {number}
     * @memberof BookSummaryViewModel
     */
    numberOfClients: number;
    /**
     * 
     * @type {number}
     * @memberof BookSummaryViewModel
     */
    numberOfInvestments: number;
}

/**
 * Check if a given object implements the BookSummaryViewModel interface.
 */
export function instanceOfBookSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "totalBookValue" in value;
    isInstance = isInstance && "averagePortfolioValue" in value;
    isInstance = isInstance && "averageInvestmentValue" in value;
    isInstance = isInstance && "numberOfClients" in value;
    isInstance = isInstance && "numberOfInvestments" in value;

    return isInstance;
}

export function BookSummaryViewModelFromJSON(json: any): BookSummaryViewModel {
    return BookSummaryViewModelFromJSONTyped(json, false);
}

export function BookSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalBookValue': json['TotalBookValue'],
        'averagePortfolioValue': json['AveragePortfolioValue'],
        'averageInvestmentValue': json['AverageInvestmentValue'],
        'numberOfClients': json['NumberOfClients'],
        'numberOfInvestments': json['NumberOfInvestments'],
    };
}

export function BookSummaryViewModelToJSON(value?: BookSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'TotalBookValue': value.totalBookValue,
        'AveragePortfolioValue': value.averagePortfolioValue,
        'AverageInvestmentValue': value.averageInvestmentValue,
        'NumberOfClients': value.numberOfClients,
        'NumberOfInvestments': value.numberOfInvestments,
    };
}

